export function stylesFromStringToTag(styles: string): HTMLStyleElement {
  const stylesNode = document.createElement("style");
  stylesNode.textContent = styles.replace(/\n/g, "");
  return stylesNode;
}
